import React, { useState } from 'react';
import TopBar from './TopBar';
import CentralMap from './CentralMap';
import ServicePanel from './ServicePanel';
import CitizenPanel from './CitizenPanel';
import FinancialBar from './FinancialBar';
const Dashboard = () => {
  const [timeFilter, setTimeFilter] = useState('last30');
  const [jurisdictionFilter, setJurisdictionFilter] = useState('national');
  const [serviceFilter, setServiceFilter] = useState('all');
  const handleFilterChange = (filterType, value) => {
    switch (filterType) {
      case 'time':
        setTimeFilter(value);
        break;
      case 'jurisdiction':
        setJurisdictionFilter(value);
        break;
      case 'service':
        setServiceFilter(value);
        break;
      default:
        break;
    }
  };
  return <div className="p-4 text-white" data-id="element-104">
      {/* Top Bar - National E-Government Pulse */}
      <div className="mb-4" data-id="element-105">
        <TopBar filters={{
        time: timeFilter,
        jurisdiction: jurisdictionFilter,
        service: serviceFilter
      }} onFilterChange={handleFilterChange} data-id="element-106" />
      </div>
      {/* Main Content Area */}
      <div className="flex gap-4 min-h-[600px] mb-4" data-id="element-107">
        {/* Left Panel - Service Delivery & Operational Excellence */}
        <div className="w-80 flex-shrink-0" data-id="element-108">
          <ServicePanel filters={{
          time: timeFilter,
          jurisdiction: jurisdictionFilter,
          service: serviceFilter
        }} data-id="element-109" />
        </div>
        {/* Central Focus - Map & Key Initiatives */}
        <div className="flex-1 min-w-[600px]" data-id="element-110">
          <CentralMap filters={{
          time: timeFilter,
          jurisdiction: jurisdictionFilter,
          service: serviceFilter
        }} data-id="element-111" />
        </div>
        {/* Right Panel - Citizen Engagement & Impact */}
        <div className="w-80 flex-shrink-0" data-id="element-112">
          <CitizenPanel filters={{
          time: timeFilter,
          jurisdiction: jurisdictionFilter,
          service: serviceFilter
        }} data-id="element-113" />
        </div>
      </div>
      {/* Bottom Bar - Financial Health & System Integrity */}
      <div data-id="element-114">
        <FinancialBar filters={{
        time: timeFilter,
        jurisdiction: jurisdictionFilter,
        service: serviceFilter
      }} data-id="element-115" />
      </div>
    </div>;
};
export default Dashboard;